// component
import { useTranslation } from 'react-i18next';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { COUPON_ROUTE, DRIVER_REPORT_ROUTE, INVOICE, MERCHANT_DETAIL, MERCHANT_USER_ROUTE, PAYMENT_REPORT_ROUTE, PROMOTION_ROUTE, RETURN_ORDER_ROUTE } from '../../../routes/paths';
import MY_ORDER_ICON from '../../../assets/images/drawer_icons/my_order.svg';
import CATEGORY_MANAGEMENT_ICON from '../../../assets/images/drawer_icons/category_management.svg';
import PRODUCT_ICON from '../../../assets/images/drawer_icons/product.svg';
import MERCHANT_USER_ICON from '../../../assets/images/drawer_icons/merchant_user_icon.svg';
import DASHBOARD_ICON from '../../../assets/images/drawer_icons/dashboard_icon.svg';
import SALES_REPORT_ICON from '../../../assets/images/drawer_icons/sales_report_icon.svg';
import { MerchantUserModel } from '../../../models/merchantUser';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
// ----------------------------------------------------------------------

// const icon = (name: string) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

interface IconImageProps {
  imageUrl: string,
  width?: string,
  height?: string
}

const IconImage = ({ imageUrl, height = "24px", width = "24px" }: IconImageProps) => {
  return <img src={imageUrl} alt="" style={{
    width,
    height
  }} />
}

const useNavConfig = () => {
  const { t } = useTranslation("global");
  const authData: MerchantUserModel = useSelector((state: RootState) => state?.auth?.data ?? null!);

  const navConfig = authData?.roleId === "64b6070fcbb774762d87f51d"
    ?
    [
      {
        title: t("drawer_component.Dashboard"),
        path: '/home',
        // icon: icon('ic_analytics'),
        icon: <IconImage imageUrl={DASHBOARD_ICON} />
      },
      {
        title: t("drawer_component.My Order"),
        path: '/order',
        icon: < IconImage imageUrl={MY_ORDER_ICON} />
      },
      {
        title:  t("drawer_component.Return Order"),
        path: RETURN_ORDER_ROUTE,
        icon: < IconImage imageUrl={MY_ORDER_ICON} />
      },
      {
        title: t("drawer_component.Sales Report"),
        path: '/sales-report',
        icon: <IconImage imageUrl={SALES_REPORT_ICON} />
      },
      {
        title: t("drawer_component.Product"),
        path: '/productMerchant',
        icon: < IconImage imageUrl={PRODUCT_ICON} />,   
      },
      {
        title: t("drawer_component.Categories"),
        path: '/categoriesBranch',
        icon: < IconImage imageUrl={CATEGORY_MANAGEMENT_ICON} />
      },
      {
        title:  t("drawer_component.Staff"),
        path: MERCHANT_USER_ROUTE,
        icon: < IconImage imageUrl={MERCHANT_USER_ICON} />
      },
      {
        title: (t("drawer_component.Merchant Detail")),
        path: MERCHANT_DETAIL,
        icon: < IconImage imageUrl={MERCHANT_USER_ICON} />
      },
      {
        title: "Invoice",
        path: INVOICE,
        icon: <IconImage imageUrl={DASHBOARD_ICON} />
      },
    ]
    :
    authData?.roleId === "64b60701cbb774762d87f51c"
      ?
      [
        {
          title: 'Dashboard',
          path: '/home',
          // icon: icon('ic_analytics'),
          icon: <IconImage imageUrl={DASHBOARD_ICON} />
        },
        {
          title: "My order",
          path: '/order',
          icon: < IconImage imageUrl={MY_ORDER_ICON} />
        },
        {
          title: "Return order",
          path: RETURN_ORDER_ROUTE,
          icon: < IconImage imageUrl={MY_ORDER_ICON} />
        },
        {
          title: "Product Merchant",
          path: '/productMerchant',
          icon: < IconImage imageUrl={PRODUCT_ICON} />,
        },
        {
          title: 'Jiffy Categories',
          path: '/categoriesBranch',
          icon: < IconImage imageUrl={CATEGORY_MANAGEMENT_ICON} />
        },
      ]
      :
      [
        {
          title: 'Dashboard',
          path: '/home',
          // icon: icon('ic_analytics'),
          icon: <IconImage imageUrl={DASHBOARD_ICON} />
        },
        {
          title: "My order",
          path: '/order',
          icon: < IconImage imageUrl={MY_ORDER_ICON} />
        },
        {
          title: "Return order",
          path: RETURN_ORDER_ROUTE,
          icon: < IconImage imageUrl={MY_ORDER_ICON} />
        },
        {
          title: "Sales Report",
          path: '/sales-report',
          icon: <IconImage imageUrl={SALES_REPORT_ICON} />
        },
        {
          title: "Product Merchant",
          path: '/productMerchant',
          icon: < IconImage imageUrl={PRODUCT_ICON} />,
        },
        {
          title: 'Jiffy Categories',
          path: '/categoriesBranch',
          icon: < IconImage imageUrl={CATEGORY_MANAGEMENT_ICON} />
        },
        {
          title: 'Staff',
          path: MERCHANT_USER_ROUTE,
          icon: < IconImage imageUrl={MERCHANT_USER_ICON} />
        },
      ]
    ;

  return {
    navConfig
  }
}



export default useNavConfig;
